let color_label = document.querySelectorAll('.product__color');
let color_swatches = document.querySelectorAll('.card__swatches');
color_swatches.forEach(el => {
  if(el.querySelector('.product__color')){
    el.querySelector('.product__color').classList.add('active')
  }
})

const swap_image = event => {
   event.target.closest('.card__swatches').querySelectorAll('li').forEach(el => {
    if(el == event.target.closest('.product__color')){
      el.classList.add('active');
    }else{
      el.classList.remove('active');
    }
  })
    
  let old_img_element = event.target.closest('.product-card').querySelector('.card__img img');
  //If variant has no image - left basic one
  let new_img_src =  event.target.closest('.product__color').dataset.imgSrc ?     
    event.target.closest('.product__color').dataset.imgSrc :
    old_img_element.dataset.src;
  if (new_img_src){
      old_img_element.src = new_img_src;
  }
   
}


color_label.forEach(el => el.addEventListener('click', swap_image));